<template>
      <ValidationObserver ref="formkiw">
        <form @submit.prevent="validate" id="usrsetupcc">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 mt-2 mb-2">
                        <div class="or-container">
                            <div class="line-separator"></div>
                            <div class="or-label">Service and Billing Agreement</div>
                            <div class="line-separator"></div>
                        </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <iframe ref="iframeRef" :src="`/service-billing-agreement${isMinimumSpend ? '?version=4' : ''}`" width="100%" height="420px" @load="onIframeLoad" style="border-radius: 8px;" />
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 ">
                    <base-checkbox :disabled="agreeTermDisable" v-model="agreeTermBilling" class="pull-left" :class="{'has-danger': agreeTermStatBilling}">I have read and agree to the <a :href="`/service-billing-agreement${isMinimumSpend ? '?version=4' : ''}`" target="_blank" style="color:#919aa3;text-decoration:underline;font-weight:bold" :style="[agreeTermStatBilling?{'color':'#ec250d'}:'']"> service and billing agreement</a></base-checkbox> 
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12 ">
                    <base-checkbox :disabled="agreeTermDisable" v-if="$store.getters.userData.user_type != 'client'" v-model="agreementCharge" :class="{'has-danger': agreementChargeError}">
                        I agree to a 12-month contract including the minimum spend requirement set forth in Addendum C of the Service and Billing Agreement.
                        <!-- I agree to a 12-month contract with a minimum spend of ${{ MINIMUM_SPEND_FLAT }}/month. -->
                         <!-- I agree to a 12-month contract with a minimum spend of ${{ minspend_setting.first_month }} after 30 days, ${{ minspend_setting.second_month }} after 60 days, and ${{ minspend_setting.monthly }}/month thereafter. -->
                    </base-checkbox>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import { mapActions } from "vuex";
import { decryptData } from '../../../helpers/crypto'
import { DOCUMENTS, MINIMUM_SPEND } from '../../../shared/constants'

export default {
    props: {
        isMinimumSpend: Boolean,
    },
    data() {
        return {
            agreeTermDisable: true,
            agreeTermBilling: false,
            agreeTermStatBilling: false,
            agreementCharge: false,
            agreementChargeError: false,
            minspend_setting:{
                status:false,
                first_month:0,
                second_month:0,
                monthly:0
            },
        }
    },
    computed: {
        MINIMUM_SPEND_FLAT(){
            return MINIMUM_SPEND.FLAT
        }
    },
    methods: {
        ...mapActions(['userLogSaved','userServiceAgreementConfirm']),
        onIframeLoad(){
            const iframe = this.$refs.iframeRef;
            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                const iframeWin = iframe.contentWindow;

                const style = iframeDoc.createElement('style');
                style.innerHTML = `
                    .full-page { min-height: 0 !important; }
                    .full-page > .content { min-height: 0 !important; padding-top: 0 !important; padding-bottom: 10px !important; }
                `;
                iframeDoc.head.appendChild(style);

                const check = () => {
                    const docEl = iframeDoc.documentElement;
                    const scrollHeight = docEl.scrollHeight;
                    const clientHeight = docEl.clientHeight;
                    const scrollTop = docEl.scrollTop || iframeWin.pageYOffset || 0;

                    if (scrollHeight <= clientHeight + 10) {
                        this.agreeTermDisable = false;
                        return true;
                    }
                    if (scrollTop + clientHeight >= scrollHeight - 10) {
                        this.agreeTermDisable = false;
                        return true;
                    }
                    return false;
                };

                iframeDoc.addEventListener('scroll', check, { passive: true });

                let pollCount = 0;
                const maxPolls = 20;
                const poll = setInterval(() => {
                    pollCount++;
                    if (check() || pollCount >= maxPolls) {
                        clearInterval(poll);
                    }
                }, 500);
            } catch (e) {
                this.agreeTermDisable = false;
                console.warn('cross-origin restriction.');
            }
        },
        checkDocumentUrl(){
            const userData = this.$store.getters.userData;
            if(this.isMinimumSpend){
                // return DOCUMENTS.MINIMUM_SPEND_V2;
                // return DOCUMENTS.MINIMUM_SPEND_V3;
                return DOCUMENTS.MINIMUM_SPEND_V4;
            } else if (userData.user_type != 'client'){
                return DOCUMENTS.DEFAULT_AGENCY;
            } else if (userData.user_type == 'client'){
                return DOCUMENTS.DEFAULT_CLIENT;
            } else {
                return ''
            }
        },
        async agreementDataWallet() {
            const userData = this.$store.getters.userData
            if (
                ['userdownline', 'user'].includes(userData.user_type) && // jika agency
                this.$global.idsys == this.$global.masteridsys && // jika di bawah root emm saja
                this.$global.betaFeature.data_wallet.is_beta && (this.$global.betaFeature.data_wallet.apply_to_all_agency || this.$global.isBeta) // jika data wallet masih beta dan (apply to all atau user ini beta)
            ) {
                const feature_id = this.$global.betaFeature.data_wallet.id;
                const feature_slug = this.$global.betaFeature.data_wallet.slug;
                const feature_name = this.$global.betaFeature.data_wallet.name;
                const payload = {
                    feature_id: feature_id,
                    feature_slug: feature_slug,
                    feature_name: feature_name,
                    user_id: userData.id,
                    is_marketing_services_agreement_feature: 'T',
                    company_name: userData.company_name,
                    company_id: userData.company_id,
                    location_menu: this.$route.name,
                };
                await this.$store.dispatch('marketingServicesAgreementFeature', payload);
            }
        },
        async validate(){
            const userData = this.$store.getters.userData;

            $('.btnNext0').attr('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> <span style="margin-left: 8px;">Loading...</span>');
            const document = await this.$store.dispatch('getDocumentAgreementFile', {
                // name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V2 : DOCUMENTS.DEFAULT_AGENCY,
                // name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V3 : DOCUMENTS.DEFAULT_AGENCY,
                name: this.isMinimumSpend ? DOCUMENTS.MINIMUM_SPEND_V4 : DOCUMENTS.DEFAULT_AGENCY,
            })

            const isNotClient = userData.user_type != 'client';
            if(isNotClient && !this.agreementCharge){
                this.agreementChargeError = true;

                this.$notify({
                    type: 'danger',
                    message: 'You must agree to Contract Agreement before continuing',
                    icon: 'fas fa-bug'
                })

                $('.btnNext0').attr('disabled', false).html('Next');
                return;
            }

            if(this.agreeTermBilling){
                let desc = `The user has agreed to the Service and Billing Agreement. | Menu: Use Existing Credit Card | fileUrl: ${document.url}`;

                const payload = {
                    userID: userData.id,
                    action: "Service and Billing Agreement",
                    desc,
                    userIP: this.$store.getters.userData.ip_login,
                    target_userID: userData.id,
                }
                const payload_agreement = {
                    userID: userData.id,
                    document_type: this.checkDocumentUrl(),
                }
                const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                if (userViewMode) {
                    const userRoot = this.$global.getSessionStorage('userDataOri') || this.$global.getlocalStorage('userDataOri');
                    if (userRoot) payload.userID = userRoot.id;
                }
                
                await this.userLogSaved({ data: payload });
                await this.onLogsContractAgreement(document);
                await this.userServiceAgreementConfirm({ data: payload_agreement });
                await this.agreementDataWallet();
                this.makeFinishSetup();
                
                $('.btnNext0').attr('disabled', false).html('Next');
                return true
            } else {
                this.agreeTermStatBilling = true;
                $('.btnNext0').attr('disabled', false).html('Next');
                return false
            }
        },
        makeFinishSetup() {
            var user = this.$store.getters.userData
            this.$store.dispatch('userSetupComplete', {
                usrID: user.id,
                statuscomplete: 'T',
            }).then(response => {
                //console.log(response.params)
                /*this.$store.dispatch('setUserData', {
                    user: response.params,
                });*/
                this.$store.dispatch('retrieveUserData',{
                        usrID: user.id,
                });
                this.$global.creditcardsetup = true;
            },error => {
                
            });
        },
        async onLogsContractAgreement(document){
            const userData = this.$store.getters.userData;
            
            // let desc = `The user has agreed 12-month contract with a minimum spend of ${ this.minspend_setting.first_month } after 30 days, ${ this.minspend_setting.second_month } after 60 days, and ${ this.minspend_setting.monthly }/month thereafter.`
            let desc = `The user has agreed 12-month contract with a minimum spend of ${ MINIMUM_SPEND.FLAT }/month.`
            desc += `| Menu: Use Existing Credit Card | fileUrl: ${document.url}`;

            const payload = {
                userID: userData.id,
                action: "Service and Billing Agreement - Startup Fee & Minimum Spend",
                desc,
                userIP: this.$store.getters.userData.ip_login,
                target_userID: userData.id,
            }
            const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            if (userViewMode) {
                const userRoot = this.$global.getSessionStorage('userDataOri') || this.$global.getlocalStorage('userDataOri');
                if (userRoot) payload.userID = userRoot.id;
            }

            await this.userLogSaved({ data: payload });
        },
    },
    mounted() {
        this.minspend_setting = this.$global.rootminspendsetting ? this.$global.rootminspendsetting : this.minspend_setting;    
    },
    watch: {
        agreeTermBilling: {
            handler(newValue){
                if(newValue){
                    this.agreeTermStatBilling = false;
                }
            }
        },
        agreementCharge: function(value) {
            if (value == true) {
                this.agreementChargeError = false;
            }
        },
    }
}
</script>

<style>

</style>